module.exports = __webpack_public_path__ + "static/media/test4_1.e7c35da6.png";